module.exports = {"TXTWCL_All_N0_Markets":{"id":"TXTWCL_All_N0_Markets","defaultMessage":"Tutte le tipologie di scommessa su: {0}"}}